import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/system";
import { IoMdClose } from "react-icons/io";
import { APIPath, token } from "../../config/api";
import { Edit } from "@mui/icons-material";
import './TransferForm.css';
const StyledDashboardContainer = styled(Grid)(({ theme, open }) => ({
    background: "rgba(204,204,204,0.2)",
    marginTop: "1%",
    marginLeft: open ? theme.spacing(30) : theme.spacing(8),
    width: open ? "80%" : "94%",
    transition: "margin-left 0.3s ease",
    height: "100vh",
}));

const TransferDetails = ({ close, open, transferId, transferDetails, loadTransferList }) => {

    document.body.style.overflow = 'hidden';
    const [isLoading, setIsLoading] = useState(false);
    const [editing,setEditing]=useState(false);
    const [newCost,setNewCost]=useState(transferDetails?.supplierCost);
    const [isEditingPrice,setIsEditingPrice]=useState(false);

    const deleteAgent = () => {
        setIsLoading(true)
        let confirm = window.confirm("Are you sure to delete this transfer? ")
        if (confirm) {
            fetch(`${APIPath}/api/v1/agency/transfers?id=${transferId} `, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                method: 'DELETE',
                mode: "cors",
            })
                .then((res) => res.json())
                .then((data) => {
                    setIsLoading(false)
                    alert("transfer deleted");
                    close();
                    loadTransferList();
                })
                .catch((error) => {
                    alert('Error fetching Transfer list:', error);
                    setIsLoading(false)
                });
        }
        else {
            console.log("Transfer not deleted");
            return
        }
    }
    const saveEditedCost=()=>{
        setEditing(false);
        setIsEditingPrice(true);
        fetch(`${APIPath}/api/v1/agency/transfers?id=${transferId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            method: 'PATCH',
            mode: "cors",
            body: JSON.stringify({
                currency: transferDetails?.supplierCurrency,
                cost: Number(newCost)
            })
        })
            .then((res) => res.json())
            .then((data) => {
                alert("Transfer cost updated");
                close();
                loadTransferList();
            })
            .catch((error) => {
                alert('Error updating transfer cost:', error);
            }).finally(() => {
                setIsEditingPrice(false);
            });
    }

    return <StyledDashboardContainer open={open}>
        <div className="booking-details-container" style={{zIndex:'9999'}}>
            <div className="booking-details-page">
                <div className="booking-pkg-pass-header">
                    <h4>Transfer Details</h4>
                    <h2 onClick={close}><IoMdClose /></h2>
                </div>
                <div className="transfer-detail-region">
                    <h2>Region Info</h2>
                    <div className="transfer-detail-region-value">
                        <div className="transfer-detail-region-info">
                            <h4>Country:</h4>
                            <p>{transferDetails?.countryName}</p>
                        </div>
                        <div className="transfer-detail-region-info">
                            <h4>City:</h4>
                            <p>{transferDetails?.cityName}</p>
                        </div>
                        <div className="transfer-detail-region-info">
                            <h4>Service Type:</h4>
                            <p>{transferDetails?.type}</p>
                        </div>
                        <div className="transfer-detail-region-info">
                            <h4>Transfer Type:</h4>
                            <p>{transferDetails?.transferType}</p>
                        </div>
                    </div>
                    <div className="transfer-detail-region-value">
                        <div className="transfer-detail-region-info">
                            <h4>Pick Up:</h4>
                            <p>{transferDetails?.pickup}</p>
                        </div>
                        <div className="transfer-detail-region-info">
                            <h4>Drop Off:</h4>
                            <p>{transferDetails?.dropoff}</p>
                        </div>
                    </div>
                </div>
                <div className="transfer-detail-region">
                    <h2>Vehicle Info</h2>
                    <div className="transfer-detail-region-value">
                        <div className="transfer-detail-region-info">
                            <h4>Image: &nbsp;</h4>
                            <p><img src={transferDetails?.vehicle?.images[0]} height={100} width={100} alt="Vehicle" /></p>
                        </div>
                        <div className="transfer-detail-region-info">
                            <h4>Name:</h4>
                            <p>{transferDetails?.vehicle?.name}</p>
                        </div>
                        <div className="transfer-detail-region-info">
                            <h4>Max. Passengers Allowed:</h4>
                            <p>{transferDetails?.vehicle?.maxPassenger}</p>
                        </div>
                    </div>
                    <div className="transfer-detail-region-value">
                        <div className="transfer-detail-region-info" style={{width:'70%'}}>
                            <h4>Additional Info:</h4>
                            <p>{transferDetails?.additionalDetails}</p>
                        </div>
                        {isEditingPrice ? <div className="loader"></div>:
                        <div className="transfer-detail-region-info">
                            <h4>Cost:</h4>
                            {editing ? <div className="price_input_and_button">
                                <input className="price_input"
                                 pattern="{0-9}"
                                value={newCost}
                                  onChange={(e)=>{
                                      const value = e.target.value;
                                      const regX=/^\d*\.?\d*$/;
                                      if (regX.test(value)) {
                                        setNewCost(value);
                                    }
                                  }
                                }
                                />
                                <button onClick={saveEditedCost}>save</button>
                                <button id="cancel_button"
                                onClick={()=>setEditing(false)}
                                >cancel</button>
                            </div>:
                            <p className="price_with_edit_icon">
                                <b> {transferDetails?.supplierCurrency} {transferDetails?.supplierCost}</b>
                                <Edit fontSize="small" cursor='pointer'
                                onClick={()=>{
                                     setEditing(true);
                                }}
                                />
                                </p>
                            }
                        </div>
                        }
                    </div>
                </div>
                {isLoading ? (<div className="loader"></div>) : (
                    <div className="agent-delete-btn"
                    style={{gap:'1rem'}}>
                        {/* <button onClick={()=>{
                            setEditing(true);
                        }}>
                            <Edit fontSize="18px"/>
                            <span>Edit</span>
                        </button> */}
                        <button
                            onClick={() => {
                                deleteAgent();
                            }}
                        >
                            <img src="deleteicon.svg" alt="." />
                            Delete
                        </button>
                    </div>
                )}
            </div>
            {/* {editing && <EditTransferPrice/>} */}
        </div>
    </StyledDashboardContainer>
};

export default TransferDetails;

const EditTransferPrice=()=>{
    return (
        <div className="editing_price_page">
            <div className="editing_price_section">
                <p>Edit Price of this Transfer</p>
            </div>
        </div>
    )
}
